<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div *ngIf="fileHash" class="avoid-break" fxLayout="row" fxLayoutAlign="start center">
    <ng-container *ngIf="(fileType$|async) === 'image'; then thumbnail else icon"></ng-container>

    <button mat-icon-button *ngIf="dataForm !== ''" matTooltip='Remove file' aria-label="remove" (click)="confirmRemove()">
        <mat-icon svgIcon="trash" aria-label="Remove"></mat-icon>
    </button>
</div>

<ng-template #thumbnail>
    <img (click)="download()"
         (load)="imageLoaded()"
         [src]="thumbnailUrl$|async"
         alt="Image Thumbnail"/>
</ng-template>

<ng-template #icon>
    <button mat-icon-button (click)="download()" matTooltip='Download'>
        <mat-icon [svgIcon]="icon$|async"></mat-icon>
    </button>
</ng-template>